var render = function render(){var _vm=this,_c=_vm._self._c;return _vm._m(0)
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"foot"},[_c('div',{staticClass:"flex"},[_c('p',[_vm._v("以上最终内容解释权归格瑞电竞俱乐部所有")]),_c('a',{attrs:{"href":"https://beian.miit.gov.cn/","target":"_blank"}},[_vm._v("鲁ICP备2026012759号-1")]),_vm._v("  |  "),_c('a',{attrs:{"href":"https://beian.mps.gov.cn/#/query/webSearch","target":"_blank"}},[_vm._v("鲁公网安备37010102007052号")])])])
}]

export { render, staticRenderFns }